import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AlertController, IonContent, ModalController, ToastController} from '@ionic/angular';
import {DocumentModel} from '../../../models/document.model';
import {CustomerModel} from '../../../models/customer.model';
import {SiteModel} from '../../../models/site.model';
import {ContactModel} from '../../../models/contact.model';
import {LokijsService} from '../../../services/database/lokijs.service';
import {GeneralService} from '../../../services/general.service';
import {FindGeoLocationService} from '../../../services/find-geo-location.service';
import {ConfigurationService} from '../../../services/configuration.service';
import {PersistDocumentService} from '../../../services/persist-document.service';
import {CheckTransportAddedService} from '../../../services/check-transport-added.service';
import {ValidateDocumentService} from '../../../services/validate-document.service';
import {AdjustDetailLinesDatesService} from '../../../services/adjust-detail-lines-dates.service';
import {GeneralSaveDocumentService} from '../../../services/general-save-document.service';
import {HandleAccessoriesService} from '../../../services/handle-accessories.service';
import {DateAsNumberService} from '../../../services/date-as-number.service';
import {PhotoDTOModel} from '../../../models/photoDTO.model';
import {DetaillineDTOModel} from '../../../models/detaillineDTO.model';

@Component({
    selector: 'app-stocking-health-care',
    templateUrl: './stocking-health-care.page.html',
    styleUrls: ['./stocking-health-care.page.scss'],
})
export class StockingHealthCarePage implements OnInit {

    @ViewChild('content') content: IonContent;
    @Input() document: DocumentModel;
    documentTemp: DocumentModel;

    constructor(private customer: CustomerModel,
                private site: SiteModel,
                private contactModel: ContactModel,
                private sigContactModel: ContactModel,
                private alertController: AlertController,
                private modalController: ModalController,
                private loki: LokijsService,
                private toastController: ToastController,
                private generalServices: GeneralService,
                private findGeoLocation: FindGeoLocationService,
                private config: ConfigurationService,
                private persistDocService: PersistDocumentService,
                private checkTransportAdded: CheckTransportAddedService,
                private validateDoc: ValidateDocumentService,
                private adjustDetailLinesDates: AdjustDetailLinesDatesService,
                private generalSaveDocument: GeneralSaveDocumentService,
                private handleAccessories: HandleAccessoriesService,
                private dateAsNumberService: DateAsNumberService) {
    }

    ngOnInit() {
        this.documentTemp = JSON.parse(JSON.stringify(this.document));
    }

    ionViewDidEnter() {
        this.content.scrollToTop(200);
    }


    listenDocument(event: DocumentModel) {
        if (event.documentType === 0) {
            this.documentTemp = event;
        } else {
            const docTypeTemp = this.document.documentType;
            this.documentTemp = event;
            this.documentTemp.documentType = docTypeTemp;
        }
        if (!(this.documentTemp.photosURL)) {
            this.documentTemp.photosURL = new Array<PhotoDTOModel>();
        }
    }

    listenCustomer(event) {
        this.documentTemp.customer = event;
        this.documentTemp.contact = new ContactModel();
        this.documentTemp.signatureContact = new ContactModel();
        this.documentTemp.site = new SiteModel();
        this.documentTemp.signature = null;
        this.documentTemp.detailLines = new Array<DetaillineDTOModel>();
    }

    listenSignature(event: string) {
        if (event) {
            this.documentTemp.queuedToOperatorId = null;
        }
    }

    saveContract() {
        if (!this.validateDoc.isValid(this.documentTemp)) {
            return;
        } else {
            this.document = JSON.parse(JSON.stringify(this.documentTemp));
            this.generalSaveDocument.generalSaveDocument(this.document);
        }
    }

    async cancelContract() {
        if (JSON.stringify((this.document)) !== JSON.stringify(this.documentTemp)) {
            const alert = await this.alertController.create({
                message: 'Do you want to cancel the Contract?',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                        }
                    }, {
                        text: 'Yes',
                        handler: () => {
                            this.modalController.dismiss();
                        }
                    }
                ]
            });
            await alert.present();
        } else {
            this.modalController.dismiss();
        }
    }

}
